import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsTemperatureMetadataServices = {
  //Temperature Metadata
  addNewEIWRSTemperatureMetadata,
  updateEIWRSTemperatureMetadataData,
  deleteEIWRSTemperatureMetadataData,
  softDeleteRestoreEIWRSTemperatureMetadata,
  getEIWRSTemperatureMetadataData,
};

// Add New Shipment Temperature Metadata
async function addNewEIWRSTemperatureMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSTemperatureMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Shipment Temperature Metadata
async function updateEIWRSTemperatureMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSTemperatureMetadataData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Shipment Temperature Metadata
async function softDeleteRestoreEIWRSTemperatureMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSTemperatureMetadata`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Shipment Temperature Metadata
async function deleteEIWRSTemperatureMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSTemperatureMetadataData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Shipment Temperature Metadata
async function getEIWRSTemperatureMetadataData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSTemperatureMetadataData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSTemperatureMetadataData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}